export default __webpack_public_path__ + "static/media/INSHA BANGLES PRIVATE LIMITED_page-0001.7ccb00b2.jpg";